// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextareaField_textarea__18NsS","caption":"TextareaField_caption__1RILC","charCounter":"TextareaField_charCounter__2pscX"};